import { MenuItem, TextField } from '@mui/material'
import dayjs from 'dayjs';
import React, { forwardRef, memo, useCallback, useImperativeHandle, useState } from 'react'
import { useSelector } from 'react-redux';

const PeriodDropDown = forwardRef(({ custom, onChange, sx = {} }, ref) => {
    const [value, setvalue] = useState({ current: "Fyear", previous: "Fyear" })
    const userPrefrenceandFY = useSelector(
        (state) => state.userPrefrenceandReducer
    );
    const reset = () => setvalue((prev) => ({ ...prev, current: prev.previous, }))
    useImperativeHandle(ref,
        () => ({
            reset
        }))

    const makePeriod = useCallback((e) => {
        let value = e.target.value
        setvalue((prev) => ({ previous: prev.current, current: value }))
        const fstart = dayjs.unix(userPrefrenceandFY?.financialYear?.startdate);
        const fend = dayjs.unix(userPrefrenceandFY?.financialYear?.enddate);
        const startOfDay = fstart.startOf('day').unix(); // Convert to UNIX timestamp in seconds
        const endOfDay = fend.endOf('day').unix();
        let start, end = 0
        switch (value) {
            case 'Today':
                start = dayjs().startOf('day').unix()
                end = dayjs().endOf('day').unix();
                break;
            case 'Week':
                start = dayjs().startOf('week').unix();
                end = dayjs().endOf('week').unix();
                break;
            case 'Month':
                start = dayjs().startOf('month').unix();
                end = dayjs().endOf('month').unix();
                break;
            case 'Quarter':
                start = dayjs().startOf('quarter').unix();
                end = dayjs().endOf('quarter').unix();
                break;
            case 'Fyear':
                start = startOfDay
                end = endOfDay
                break;
            case 'Custom':
                custom()
                break;
            default: break
        }
        console.log(start, end, userPrefrenceandFY?.financialYear)
        if (value != "Custom")
            onChange(Math.round(start), Math.round(end))
        return {
            start: "", end: ""
        }
    }, [userPrefrenceandFY, setvalue, onChange, custom])

    return (
        <TextField
            select
            defaultValue={'Fyear'}
            id="financialYear"
            label=""
            value={value.current}
            variant="outlined"
            size="small"
            onChange={makePeriod}
            sx={{
                minWidth: "174px",
                color: "#fff",
                marginRight: "10px",
                ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                    fontSize: "12px",
                },
                label: {
                    fontSize: "12px",
                },
                ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                    fontSize: "12px",
                },
                ".css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
                {
                    fontSize: "12px",
                },
                ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "none",
                    borderBottom: "solid 1px #fff",
                    borderColor: "#fff",
                },
                ".MuiSelect-select": {
                    color: "white",
                    border: "1px solid white",
                    outlineColor: "white"
                },
                ".MuiOutlinedInput-root": {
                    // borderRadius: "10px",
                    border: "1px solid white",
                },
                ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                    borderColor: "#fff",
                },
                ".css-hfutr2-MuiSvgIcon-root-MuiSelect-icon": {
                    color: "#fff",
                },
                ".css-bpeome-MuiSvgIcon-root-MuiSelect-icon": {
                    color: "#fff",
                },
                ".css-1wbek56-MuiFormLabel-root-MuiInputLabel-root": {
                    color: "#ffffff99",
                },
                ".css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
                {
                    color: "#fff",
                },
                ...sx
            }}
        >
            <MenuItem value={"Fyear"} >This Financial Year</MenuItem>
            <MenuItem value={'Quarter'}>This Quarter</MenuItem>
            <MenuItem value={'Month'}>This Month</MenuItem>
            <MenuItem value={'Week'}>This Week</MenuItem>
            <MenuItem value={'Today'}>Today</MenuItem>
            <MenuItem value={"Custom"} >Custom</MenuItem>
        </TextField>
    )
})

export default memo(PeriodDropDown)